import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Row } from 'reactstrap';
import OrganizationUserService from '../../Services/QRCodeServices/OrganizationUserService/OrganizationUserService';
import DataTable from 'react-data-table-component';
import { Triangle } from 'react-loader-spinner';

export const OrganizationUser = () => {
  const [users, setUsers] = useState([]); // State to store the fetched users
  const [loading, setLoading] = useState(true); // Loading state
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalData: 0,
  }); // Pagination state

  // Function to remove duplicates based on userName
  const removeDuplicates = (data) => {
    const uniqueUsers = [];
    const seenUserNames = new Set();

    for (const user of data) {
      if (!seenUserNames.has(user.userName)) {
        seenUserNames.add(user.userName);
        uniqueUsers.push(user);
      }
    }

    return uniqueUsers;
  };

  // Fetch users from the API
  const fetchUsers = async (pageNumber, pageSize) => {
    setLoading(true);
    try {
      const response = await OrganizationUserService.getList({
        pageNumber,
        pageSize,
      });

      console.log("API Response:", response); // Debug the response

      // Extract the data array based on the API response structure
      const data = response?.data || response || []; // Adjust based on the API response

      // Remove duplicates from the data
      const uniqueData = removeDuplicates(data);

      setUsers(uniqueData); // Set unique users
      setPagination((prev) => ({
        ...prev,
        totalData: uniqueData.length, // Use the length of unique data
      }));
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
    fetchUsers(page, pagination.pageSize);
  };

  // Handle rows per page change
  const handlePerRowsChange = (pageSize) => {
    setPagination((prev) => ({ ...prev, pageSize, page: 1 }));
    fetchUsers(1, pageSize);
  };

  // Fetch users on component mount
  useEffect(() => {
    fetchUsers(pagination.page, pagination.pageSize);
  }, []);

  // Debug the users state
  useEffect(() => {
    console.log("Users:", users);
  }, [users]);

  // Columns for the data table
  const columns = [
    {
      name: 'Customer Name/Contact',
      selector: (row) => row?.userName, // Access the userName property
      sortable: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="User List" pageTitle="User Management" />
        <Row>
          <DataTable
            columns={columns}
            data={users} // Use the unique users
            pagination
            paginationServer
            paginationTotalRows={pagination.totalData}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={{
              headCells: { style: { fontSize: '0.93rem', fontWeight: 610 } },
              rows: { style: { fontSize: '0.9rem' } },
            }}
            progressComponent={
              <div className="my-3 text-center">
                <Triangle visible={true} height="80" width="80" color="#5B71B9" ariaLabel="triangle-loading" />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            noDataComponent={
              <div className="my-3 text-center">
                <h5>No records found</h5>
              </div>
            }
            onRowClicked={(row) => console.log("Row clicked:", row)} 
          />
        </Row>
      </div>
    </div>
  );
};